module.exports = __webpack_public_path__ + "static/media/gryphon-house-aerial-glow.26348f64.jpg";